module.exports = __webpack_public_path__ + "static/media/NJ0151-53M_01.abc65435.png";